import BaseButton from "Engine/base/ui/BaseButton";

export default class BaseGameButton extends BaseButton {
    constructor(data, displayData) {
        super(data, displayData);

        this.incativeTintColor = 0xCCCCCC;
    }

    get enabled() {
        return this._enabled;
    }

    set enabled(value) {
        this._enabled = value;
        if (value) {
            this.goToFrame(this.state === 'over' ? 2 : 1);
            this.interactive = true;
            this.buttonMode = true;
        } else {
            this.goToFrame(4);
            this.interactive = false;
            this.buttonMode = false;
        }

        this.children.forEach((child)=>{
            child.tint = this._enabled ? 16777215 : this.incativeTintColor;
        });
    }
}